import CMS from "./CMS/init";
import Commerce from "./Commerce/init";
import Cart from "./Cart/init";
import Admin from "./Admin/init";

export default [CMS, Commerce, Cart, Admin];